import Tasks from '../../controllers/tasks';
import autoSchedulingPatchesModule from '../../autoScheduling';

export default instance => {
  instance.attachEvent('onAfterTaskDelete', (id, task) => {
    Tasks.onAfterTaskDelete(id, task);
    autoSchedulingPatchesModule.checkLinks(id, task);
  });
};
